const defaultState = {
    notificationsLoading: false,
    unreadNotificationsCount: 0,
    notifications: {
        data: [],
        totalCount: 0,
        unreadTotalCount: 0,
    },
};

const notificationReducer = (state = defaultState, action) => {
    switch (action.type) {
        case "GET_NOTIFICATIONS_REQUEST":
            state = {
                ...state,
                notificationsLoading: true,
            };
            break;
        case "GET_NOTIFICATIONS_SUCCESS":
            state = {
                ...state,
                notificationsLoading: defaultState.notificationsLoading,
                notifications: {
                    ...state.notifications,
                    data: [...state.notifications.data, ...(action.payload?.data || [])],
                    totalCount: action.payload?.totalCount || 0,
                    unreadTotalCount: action.payload?.unreadTotalCount || 0,
                },
            };
            break;
        case "GET_NOTIFICATIONS_FAILURE":
            state = {
                ...state,
                notificationsLoading: defaultState.notificationsLoading,
                notifications: defaultState.notifications,
            };
            break;
        case "GET_UNREAD_NOTIFICATIONS_SUCCESS":
            state = {
                ...state,
                notificationsLoading: defaultState.notificationsLoading,
                unreadNotificationsCount: action.payload?.unreadTotalCount || 0
            }
    }
    return state;
};

export default notificationReducer;
